import { useTheme } from '@emotion/react';
import type { Theme } from 'styles/themes/default';

export default useTheme as () => Theme;
